import { useAuth } from '@/hooks/useAuth';
import { usePermissions } from '@/hooks/useModulePermissions';
import { Softphone } from './Softphone';

/**
 * Wrapper that only renders the Softphone when user is authenticated
 * and has phone module access. Mounted at App.tsx level.
 */
export function SoftphoneContainer() {
  const { user } = useAuth();
  const { can, isLoading } = usePermissions();

  if (!user || isLoading || !can('phone', 'read')) return null;

  return <Softphone />;
}
